const STORAGE_KEY = 'sidebar_open';

const getInitialState = () => {
  // Below 1100px the sidebar renders as a full-screen overlay (see
  // .sidenav-toggle.js-sidenav-toggle.is-active in _top-bar.scss) — it must
  // never default open there, regardless of a stored desktop preference.
  if (window.innerWidth < 1100) return false;

  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    // First visit (nothing stored) → expanded by default
    return stored === null ? true : stored === 'true';
  } catch {
    return true;
  }
};

let currentState = getInitialState();
const listeners = new Set();

export const getState = () => currentState;

export const toggle = () => {
  currentState = !currentState;
  try {
    localStorage.setItem(STORAGE_KEY, String(currentState));
  } catch {
    // localStorage not available — continue without persistence
  }
  listeners.forEach((fn) => fn(currentState));
};

export const subscribe = (fn) => {
  listeners.add(fn);
  return () => listeners.delete(fn);
};
